export default function capitalize(value) {
  if (!value) return '';
  const newValue = value.toString().toLowerCase();
  return newValue.charAt(0).toUpperCase() + newValue.slice(1);
}
